import { render } from "./faqSection.vue?vue&type=template&id=3a10a1ec&scoped=true"
import script from "./faqSection.vue?vue&type=script&lang=js"
export * from "./faqSection.vue?vue&type=script&lang=js"

import "./faqSection.vue?vue&type=style&index=0&id=3a10a1ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a10a1ec"]])

export default __exports__